import React from "react";
import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import styles from "@style/AuthProvider.module.css";
import { toPascalCase } from "@utils/toPascalCase";
import { useAtomValue } from "jotai";
import { userPhotoUrlAtom } from "@store/HostAtoms";
import { workBenchPersonId } from 'data_parser/FusionAtoms';

import ZendaiLogo from "/zendai-logo.svg";

interface AppHeaderProps {
  name: string;
  isAuthenticated: boolean;
  onMenuClick: (e: React.MouseEvent<HTMLElement>) => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ name, isAuthenticated }) => {
  const photoUrl = useAtomValue(userPhotoUrlAtom);
  const personID = useAtomValue<string>(workBenchPersonId);

  return (
    <AppBar position="static" color="transparent" sx={{ bgcolor: "rgb(245, 244, 247)" }}>
      <Toolbar className={styles.toolbar_header}>
        <Box className="flex items-center gap-3">
          <img src={ZendaiLogo} alt="Zendai Logo" className="h-10 w-10" />
          <Box sx={{ minHeight: '24px' }}>
            <Typography variant="h4" component="h4" className="text-black font-semibold">
              Zendai Fusion
              {personID != "0" && <span style={{ marginLeft: "10px", fontSize: "1rem" }}>
                Workbench ID: {personID}
              </span>}
            </Typography>
          </Box>
        </Box>

        <Box className="flex items-center gap-6 ml-auto">
          {isAuthenticated && (
            <>
              <Box className={styles.profile_name}>
                {photoUrl ? (
                  <img src={photoUrl} alt="Profile" className="h-8 w-8 rounded-full mr-2" />
                ) : (
                  <AccountCircleIcon fontSize="inherit" />
                )}
                <Typography variant="body1" fontWeight="bold">
                  Welcome, {toPascalCase(name)}!
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
